import { tryToDetectDateFormat } from 'components/common-form/builder/form/node/field/Grid/pasting';
import { supportedDateFormats } from 'components/shared/DatePicker/utils';
import { SimpleUserNotification } from 'hooks/use-simple-user-notification';
import { useSPIntl } from 'hooks/useIntl';
import { useLocalDateFormat } from 'hooks/useLocalDateFormat';
import { useCallback } from 'react';

type DateFormatDetector = (allDatesToParse: string[]) => string | null;

export type DateFormatDetectorWithNotifier = (notifier: SimpleUserNotification) => DateFormatDetector;

export function useDateFormatDetector(): DateFormatDetectorWithNotifier {
  const { formatMessage } = useSPIntl();
  const [localeDateformat] = useLocalDateFormat();

  return useCallback(
    (notifier: SimpleUserNotification) => (allDatesToParse: string[]) => {
      const allDateFormats = supportedDateFormats(localeDateformat);
      return tryToDetectDateFormat({
        dates: allDatesToParse,
        dateFormats: allDateFormats,
        formatMsg: formatMessage,
        onWarning: msg => notifier.warn(msg),
        onError: msg => notifier.error(msg),
      });
    },
    [localeDateformat, formatMessage],
  );
}
